import { ca } from '@cian/analytics';

// Клик на ссылку на ход строительства
export function trackOpenProgressOfConstruction() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'open_buildingProgress',
    label: '',
    pageType: 'CardJK',
    useLastProducts: true,
  });
}
